// import noDataImage from '../../assets/images/no-data-found.png';
import './no-data-available.scss';
import { ReactComponent as DataNotFound } from '../../assets/icons/data-not-found.svg';

interface NoDataAvailableProperties {
  title?: string;
  description?: string;
  // imageHeight?: number;
}

/**
 * No Data Available shared component
 * Displays an illustration with a title and description when there is no data to show.
 */
function NoDataAvailable({
  title = 'No Data Available Yet',
  description = 'Data Will Appear Here Once Your Station Starts Recording Activity.',
  // imageHeight = 180,
}: NoDataAvailableProperties) {
  return (
    <div className="no-data-available-wrap">
      {/* <img
        src={noDataImage}
        alt="No data available"
        className="no-data-available-image"
        style={{ height: imageHeight }}
      /> */}
      <DataNotFound />
      <h3 className="no-data-available-title">{title}</h3>
      <p className="no-data-available-description">{description}</p>
    </div>
  );
}

NoDataAvailable.defaultProps = {
  title: 'No Data Available Yet',
  description: 'Data Will Appear Here Once Your Station Starts Recording Activity.',
  // imageHeight: 180,
};

export default NoDataAvailable;
